export default __webpack_public_path__ + "static/media/whatsapp.0c3ae00f.png";